import { filterByKey } from './object.mjs';

function getQueryKey(axiosRequestConfig) {
  const { url, ...restRequestConfig } = axiosRequestConfig;
  const requestConfigExcludedFunctionType = filterByKey(
    restRequestConfig,
    (key) => typeof restRequestConfig[key] !== "function"
  );
  return [url, requestConfigExcludedFunctionType];
}

export { getQueryKey as default };
//# sourceMappingURL=getQueryKey.mjs.map
